import { Table } from "@mantine/core";
import {
  calculateSalesMetrics,
  formatNumberAsString,
  safeUnits,
} from "common/utils";
import React from "react";
import { RprtSalesAnalysisByQuarters } from "types/model.types";

interface ISalesAnalysisViewProps {
  data: RprtSalesAnalysisByQuarters | null;
}

const SalesAveragesView: React.FC<ISalesAnalysisViewProps> = ({ data }) => {
  return (
    <>
      {!data || data.length === 0 ? (
        <Table.Tr>
          <Table.Td colSpan={18}>
            No data available for the selected criteria.
          </Table.Td>
        </Table.Tr>
      ) : (
        data.map((row, index) => {
          const { avg, exAvg, ams, months } = calculateSalesMetrics(row);
          const units = safeUnits(row.unitsCtn);
          return (
            <Table.Tr key={`${index}-${row.id}`}>
              <Table.Td>{row.id}</Table.Td>
              <Table.Td>{row.description}</Table.Td>
              <Table.Td>{formatNumberAsString(row.lastSale / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.qtr1 / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.qtr2 / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.qtr3 / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.qtr4 / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.total / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(avg)}</Table.Td>
              <Table.Td>{formatNumberAsString(exAvg)}</Table.Td>
              <Table.Td>{formatNumberAsString(ams)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.cord / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.sord / units)}</Table.Td>
              <Table.Td>{formatNumberAsString(row.onHand / units)}</Table.Td>
              <Table.Td>{months}</Table.Td>
              <Table.Td>{row.onHand <= 0 ? " <<< " : ""}</Table.Td>
            </Table.Tr>
          );
        })
      )}
    </>
  );
};

export default SalesAveragesView;
